export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_768___TO_TARGET': '% to Target',
    '_7463_OA': 'OA',
    '_713_METRIC': 'Metric',
    '_725_ACTUAL': 'Actual',
    '_726_TARGET': 'Target',
    '_11051_FOCUS_SELECTOR': 'Focus Selector',
    '_11053_FOCUS_HISTORY': 'Focus History',
    '_11054_METRIC_SELECTION': 'Metric Selection',
    '_11055_FOCUS_SELECTION': 'Focus Selection',
    '_11056_LOAD_GOALS': 'Load Goals',
    '_11057_SELECTION_RESULT': 'Selection Result',
    '_11058_SELECTED_METRIC': 'Selected Metric:',
    '_11059_SELECTED_FOCUS': 'Selected Focus:',
    '_11060_BEHAVIOUR': 'Behaviour:',
    '_11061_TACTICS': 'Tactics:',
    '_11062_LOADED_GOALS': 'Loaded Goals:',
    '_11063_CONFIRM_SELECTION': 'Confirm Selection',
    '_9617_ON_SCORECARD': 'On Scorecard',
    '_11083_METRIC_PLACEHOLDER_': 'Type to search a metric...',
    '_11084_SUPERGROUP_TO_TARGET': 'Supergroup % to Target',
    '_11085_SELECT_METRIC': 'Select metric',
    '_11086_CONTINUE_WITHOUT_CONFIRM_METRIC': 'Continue without confirm metric',
    '_7489_UNCOACHED': 'Uncoached',
    '_7488_COACHED': 'Coached',
    '_7436_NON_OPPORTUNITY': 'Non-Opportunity',
    '_11087_NO_METRICTS_TO_DISPLAY': 'No metrics to display',
    '_11088_METRIC_IS_AN_CURRENT_OPPORTUNITY': 'Metric is an current opportunity',
    '_11089_METRIC_IS_ALREADY_BEING_COACHED': 'Metric is already being coached',
    '_11090_METRIC_IS_ALREADY_BEING_COACHED_BUT_IS_NOT_AN_OPPORTUNITY_KPI': 'Metric is already being coached but is not an opportunity KPI',
    '_11091_METRIC_IS_CONFIGURED_ON_PERFORMER_S_SCORECARD': 'Metric is configured on performer\'s scorecard',
    '_11092_THIS_USER_CURRENTLY_HAS_ACTIVE_COMMITMENTS': 'This user currently has active commitments',
    '_11093_FOCUS_SELECTION_PLACEHOLDER': 'Click to search for a focus...',
    '_7334_BEHAVIOUR': 'Behaviour',
    '_7307_TACTIC': 'Tactic',
    '_11094_THIS_BEHAVIOUR_HAS_NO_TACTICS': 'This behaviour has no tactics',
    '_11095_ACTIVE_FOR_THIS_PERFORMER': 'Active for this Performer',
    '_11096_RECENTLY_CLOSED_FOR_THIS_PERFORMER': 'Recently Closed for this Performer',
    '_11097_ACTIVE_FOR_YOUR_TEAM': 'Active for Your Team',
    '_11098_RECENTLY_CLOSED_FOR_YOUR_TEAM': 'Recently Closed for Your Team',
    '_777_RANK': 'Rank',
    '_7361_FOCUS': 'Focus',
    '_11099_15_DAY_FORECAST': '15 Day Forecast',
    '_11100_30_DAY_FORECAST': '30 Day Forecast',
    '_11101_60_DAY_FORECAST': '60 Day Forecast',
    '_11102_NO_CONFIGURED_FOCUSES_FOR_THIS_METRIC': 'There are no configured focuses for this metric',
    '_11103_SELECT_FOCUS': 'Select Focus',
    '_11104_CURRENT_IMPROVEMENT': 'Current Improvement',
    '_9473_DAYS_ACTIVE': 'Days Active',
    '_11105_THIS_PERFORMER_HAS_NO_ACTIVE_FOCUSES': 'This performer has no active focuses',
    '_10062_PERCENT_IMPROVEMENT': '% Improvement',
    '_11106_THERE_ARE_NO_RECENTLY_CLOSED_FOCUSES_FOR_THIS_PERFORMER': 'There are no recently closed focuses for this performer',
    '_11107_DIRECT_REPORT': 'Direct Report',
    '_11108_THERE_ARE_NO_ACTIVE_FOCUSES_FOR_YOUR_TEAM': 'There are no active focuses for your team',
    '_11109_THERE_ARE_NO_RECENTLY_CLOSED_FOCUSES_FOR_YOUR_TEAM': 'There are no recently closed focuses for your team',
    '_9479_CONFIRMATION': 'Confirmation',
    '_11110_FOCUS_ALREADY_USED_IN_ACTIVE_COMMITMENT': 'This focus is already being used in an active commitment for this user',
    '_11111_CONFIRM_DIALOG_THERE_IS_ALREADY_AN_ACTIVE_COMMITMENT_WITH_THIS_FOCUS': 'There is already an active commitment with this focus. Would you like to navigate to that commitment?',
    '_9297_YES': 'Yes',
    '_9298_NO': 'No',
    '_637_OKAY': 'Okay',
    '_121_CANCEL': 'Cancel',
    '_9977_EXPAND': 'Expand',
    '_9978_COLLAPSE': 'Collapse',
    '_763_CLOSE': 'Close',
    '_11112_ADD_METRICS_TO_FOCUS': 'Add metrics to Focus',
    '_11113_YOU_MUST_SELECT_METRIC_AND_FOCUS_TO_SET_GOALS': 'You must select a metric and a focus to set goals',
    '_11114_SELECTED_GOALS': 'Selected Goals',
    '_4106_CURRENT_ACTUAL': 'Current Actual',
    '_9779_EXPECTED_ACHIEVEMENT_DATE': 'Expected Achievement Date',
    '_11115_PERCENT_GAP_TO_TARGET': '% Gap to Target',
    '_9431__IMPROVEMENT_EXPECTED': '% Improvement Expected',
    '_9432_GOAL_VALUE': 'Goal Value',
    '_9433_START___TO_GOAL': 'Start % to Goal',
    '_9434_DAYS_TO_ACHIEVEMENT': 'Days to Achievement',
    '_711_NO_DATA_AVAILABLE': 'No Data Available',
    '_7457_TARGET_LINE': 'Target Line',
    '_7456_ACTUAL_LINE': 'Actual Line',
    '_7458_GOAL_LINE': 'Goal Line',
    '_9480_SUPERGROUP_AVERAGE': 'Supergroup Average',
    '_9454_ACTIVE_GOAL': 'Active Goal',
    '_9455_HISTORIC_GOALS': 'Historic Goals',
    '_9457_COMMITMENT_EVENT': 'Commitment Event',
    '_9458_MULTIPLE_COACHING_EVENTS': 'Multiple Coaching Events',
    '_11116_SHARED_GOAL_WARNING': 'This performer already has a goal with this metric. You cannot update the goal but the existing goal will be associated to this commitment',
    '_9430_NO_METRIC_PERFORMANCE_DATA': 'No Metric Performance Data.',
    '_11117_CONFIRM_DIALOG_CONFIRM_THIS_FOCUS_WITHOUT_ADDING_GOALS': 'Are you sure you want to confirm this focus without adding goals?'
};
